import { createSlice } from "@reduxjs/toolkit";
const openNavbarSlice = createSlice({
  name: "openNavbar",
  initialState: {
    open: false,
  },
  reducers: {
    setOpenNavbar: (state, action) => {
      state.open = action.payload;
    },
  },
});

export const { setOpenNavbar } = openNavbarSlice.actions;
export default openNavbarSlice.reducer;
